module.exports = __webpack_public_path__ + "static/model-error.2ed469d8f4b4b13c3e24a2c1da60ceea.svg";